<div class="fw-bold bg-white p-3 rounded-5 mb-3 shadow">
  <!-- Primera fila -->
  <div class="row mt-3">
    <div class="col">
      <label for="information" class="labelInformation mb-2">{{
        information
      }}</label>
    </div>
  </div>

  <!-- Segunda fila -->
  <div class="row row-cols-1 row-cols-md-3 row-gap-3">
    <div class="col">
      <label for="state" class="input-label"
        >List of plans<span class="required">*</span></label
      >
      <div class="dropdown">
        <select
          class="form-select input-label"
          [(ngModel)]="planSelected"
          (change)="checkFields()"
          [class.is-invalid]="!planSelected"
        >
          <option value="0">Select Value</option>
          <option *ngFor="let option of plans" [value]="option.planID">
            {{ option.planName }}
          </option>
        </select>
      </div>
      
    </div>

    <div class="col">
      <label for="discount">Discount $</label>
      <input
        type="text"
        class="form-control input-label"
        (input)="checkFields()"
        [(ngModel)]="discount"
        placeholder="$ 0.00"
        appValidateDecimals
      />
    </div>

    <div class="col">
      <label for="state" class="input-label"
        >Discount type<span class="required" *ngIf="discount">*</span></label
      >
      <div class="dropdown">
        <select
          class="form-select input-label"
          [(ngModel)]="tipeDiscount"
          (change)="checkFields()"
        >
          <option value="">Select Value</option>
          <option
            *ngFor="let option of listTipeDiscount"
            [value]="option.aValue"
          >
            {{ option.aDescription }}
          </option>
        </select>
      </div>
    </div>

    <div class="col">
      <label for="dateValidFrom">Valid From <span class="required">*</span></label>
      <input
        type="date"
        class="form-control input-label"
        (change)="onInputChange()"
        (input)="checkFields()"
        [(ngModel)]="dateValidFrom"
        (keydown)="false" (keypress)="false" (keyup)="false"
        id="dateValidFrom"
        name="dateValidFrom"
        [class.is-invalid]="!dateValidFrom"
      />
      <div class="invalid-feedback">
                Valid From is required
            </div>
    </div>

    <div class="col">
      <label for="dateValidUntil">Valid Until</label>
      <input
        type="date"
        class="form-control input-label"
        (input)="checkFields()"
        [(ngModel)]="dateValidUntil"
        [min]="minDate()"
        id="dateValidUntil"
        name="dateValidUntil"
      />
    </div>

    <div class="col">
      <label for="description">Description</label>
      <input
        type="text"
        class="form-control input-label"
        (input)="checkFields()"
        [(ngModel)]="description"
      />
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-4">
      <label for="prorationInitial">Proration by initial date</label>
      <input
        type="text"
        class="form-control input-label"
        disabled
        [(ngModel)]="prorationInitial"
      />
    </div>
  </div>

  <!-- Cuarta fila -->
  <div class="row mt-3">
    <div class="col text-end">
      <button
        class="btn btn-primary w-100 w-md-auto me-2"
        [disabled]="!isFiledsValid()"
        (click)="calculateProration()"
      >
        Calculate Proration
      </button>
      <button
        class="btn btn-primary w-100 w-md-auto"
        [disabled]="!fieldsCompleted"
        (click)="assignPlan()"
      >
        Assign Plan
      </button>
    </div>
  </div>
</div>
